var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/**
 * Lobby lotteries grid - template-10 variant: a card-per-lottery grid where each card has a
 * per-lottery background image and, on hover, reveals the last draw's winning numbers + a play
 * action. No quick-play / show-more. Lottery data lives on the shell (host).
 */
var LotteriesGridT10 = /** @class */ (function (_super) {
    __extends(LotteriesGridT10, _super);
    function LotteriesGridT10() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LotteriesGridT10;
}(RenderBlock));
export { LotteriesGridT10 };
